/**
 * Created by Jerker Nord on 2018-07-05.
 */

import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineMax} from "gsap";
import {IceIceYetiGameAssets} from "../../IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";

export class IceIceYetiWildInIceReelAttentionView extends BaseView {

    private _layer:ScalableLayer;
    private _reelAttention01:TimelineSprite;
    private _reelAttention02:TimelineSprite;
    private _reelAttentionAnimation:TimelineMax;
    private _reel:number;
    private _nearWinLongSoundPlaying:boolean = false;

    constructor() {
        super();
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.REEL_ATTENTION.name);
        this._layer.addChild(this);
    }

    protected initAnimations():void {
        this._reelAttentionAnimation = new TimelineMax({repeat : -1, paused : true});
        this._reelAttention01 = new TimelineSprite((GameResources.getTextures(IceIceYetiGameAssets.REEL_ATTENTION)));
        this._reelAttention01.anchor.set(0.5, 0.5);
        this._reelAttention01.show();
        this._reelAttention01.blendMode = PIXI.BLEND_MODES.ADD;
        this._reelAttention01.visible = false;
        this.addChild(this._reelAttention01);
        this._reelAttention02 = new TimelineSprite((GameResources.getTextures(IceIceYetiGameAssets.REEL_ATTENTION)));
        this._reelAttention02.anchor.set(0.5, 0.5);
        this._reelAttention02.show();
        this._reelAttention02.blendMode = PIXI.BLEND_MODES.ADD;
        this._reelAttention02.visible = false;
        this.addChild(this._reelAttention02);

        this._reelAttentionAnimation.add(this._reelAttention01.getAnimation([0, 28]));
        this._reelAttentionAnimation.add(() => this._reelAttention02.visible = true);

        //Work in progress. Loop this part
        this._reelAttentionAnimation.add([
            this._reelAttention02.getAnimation([5, 28]),
            this._reelAttention01.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention01.getAnimation([5, 28]),
            this._reelAttention02.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention02.getAnimation([5, 28]),
            this._reelAttention01.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention01.getAnimation([5, 28]),
            this._reelAttention02.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention02.getAnimation([5, 28]),
            this._reelAttention01.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention01.getAnimation([5, 28]),
            this._reelAttention02.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention02.getAnimation([5, 28]),
            this._reelAttention01.getAnimation([29])
        ]);
        this._reelAttentionAnimation.add([
            this._reelAttention01.getAnimation([5, 28]),
            this._reelAttention02.getAnimation([29])
        ]);
    }

    public playRealAttention(reel:number):void {
        this._reelAttention01.visible = true;
        this.position.x = Helper.getSymbolPositions(reel, 3)[0];
        this.position.y = Helper.getSymbolPositions(reel, 3)[1];
        this._reelAttention02.visible = false;
        this._reelAttentionAnimation.restart();
        this.playNearWinLongSound();
        this.playNearWinReelSound();
    }

    private playNearWinLongSound():void {
        if(this._nearWinLongSoundPlaying == false) {
            this._nearWinLongSoundPlaying = true;
            SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.NEAR_WIN_LONG);
        }
    }

    private playNearWinReelSound():void {
        SlotGame.sound.playEffect(IceIceYetiSoundConfig.instance.NEAR_WIN_REEL);
    }

    public reset():void {
        this._nearWinLongSoundPlaying = false;
        this._reelAttentionAnimation.kill();
        this._reelAttention01.visible = false;
        this._reelAttention02.visible = false;
        SlotGame.sound.stopEffect(IceIceYetiSoundConfig.instance.NEAR_WIN_LONG);
        SlotGame.sound.stopEffect(IceIceYetiSoundConfig.instance.NEAR_WIN_REEL);
    }

    public abort():void {
        this.reset();
    }
}